
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ROUTES_ARCHIVOS } from '../constants/constant.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class bancoService {

    constructor(
        private httpClient: HttpClient,
        private apiService: ApiService
    ) { }

    public obtener(codcont: number) {
        return this.httpClient.get(environment.serviceUrl + "contactos/" + codcont, { observe: 'response' },)
    }

    obtenerEntidad() {
        this.apiService.setUrlPathApi("general/entidades-financieras");
        return this.apiService.execGetQueryJson('');
    }
    obtenerTipoCuentas(){
        this.apiService.setUrlPathApi("general/entidades-financieras/tipo-cuentas");
        return this.apiService.execGetQueryJson('');
    }

    /*
    insertContacto(contacto: any) {
        this.apiService.setUrlPathApi("contacto");
        return this.apiService.executePostJson(contacto).pipe();
    }
    */
    /*
    actualizarMotivo(motivo: any) {
        this.apiService.setUrlPathApi("contacto/");
        return this.apiService.executePutJson(motivo).pipe();
    }

    eliminarMotivo(tipdoc: any , id:any , codmot:any) {
        this.apiService.setUrlPathApi("contacto/");
        return this.apiService.executeDeleteJson(`${tipdoc}/${id}/${codmot}`)
    }
    */
}